const textBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8.92 12.29H7.08V8.86h1.84a1.77 1.77 0 0 1 1.83 1.71 1.78 1.78 0 0 1-1.83 1.72M7.08 3.71H8a1.78 1.78 0 0 1 1.83 1.72A1.77 1.77 0 0 1 8 7.14h-.92zm4.18 3.7a2.87 2.87 0 0 0 1.3-2.75A3.25 3.25 0 0 0 9.22 2H2.5v.86l1.33.62a.84.84 0 0 1 .5.76v7.52a.84.84 0 0 1-.5.76l-1.33.62V14h7.17a3.71 3.71 0 0 0 3.82-3.12 3.43 3.43 0 0 0-2.23-3.47"/></svg>',
};

export { textBold as default };
